import moment from 'moment';

const ePosDev = new window.epson.ePOSDevice();

let instance = null;

class EPosPrinter {

    printer = null;
    //Queue, welche die einzelnen Funktionen zum Resolven der Promises enthält
    printqueue = [];
    resolveConnectFunction = null;

    articleIndentation = 80;
    maxArticleValueLength = 36;

    constructor(props) {
        if (!typeof instance === 'undefined')
            return instance;

        this.onCreateDevice = this.onCreateDevice.bind(this);
        this.onConnectDevice = this.onConnectDevice.bind(this);
    }

    onCreateDevice(deviceObj) {
        if (deviceObj === null) {
            //Displays an error message if the system fails to retrieve the Printer object
            return;
        }
        this.printer = deviceObj;

        //Registers the print complete event
        this.printer.onreceive = (response) => {
            this.printqueue.shift().resolvefunc(response.success ? "success" : "error")
        };

        //Register the print onreconnecting event
        this.printer.onreconnecting = (ev) => console.log("Reconnecting to ePos printer...");

        //register the print onreconnect event
        this.printer.onreconnect = (ev) => console.log("successfully reconnected to ePos printer");

        //register the print ondisconnect event
        this.printer.ondisconnect = (ev) => console.log("ePos printer disconnected\nTrying to reconnect...");

        console.log("Successfully connected to epos printer");
        this.resolveConnectFunction("success");
    }

    onConnectDevice(resultConnect) {
        let deviceId = 'local_printer';
        let options = { 'crypto': true, 'buffer': true };

        if ((resultConnect === 'OK') || (resultConnect === 'SSL_CONNECT_OK')) {
            //retrieve the printer object
            ePosDev.createDevice(deviceId, ePosDev.DEVICE_TYPE_PRINTER, options,
                this.onCreateDevice);
        }
        else {
            //display error messages
            console.log("Failed to retrieve the printer object");
            this.resolveConnectFunction("connecting failed");
        }

    }

    connect(ipAddress, port) {
        console.log("connecting to epos-printer...");

        if (!port || port < 8000) {
            return;
        }

        if (!ipAddress || (ipAddress.match && (ipAddress.match(/\./g) || []).length < 3)) {
            return;
        }

        console.log(ipAddress + ":" + port);

        this.ipAddress = ipAddress;
        this.port = port;

        return new Promise((resolve) => {
            this.resolveConnectFunction = resolve;
            ePosDev.connect(ipAddress, port, this.onConnectDevice);
        });
    }

    fitTextToMaxWordlength(text, maxWordlength) {
        if (!text)
            return [];

        let splittedwords = text.split(" ");
        let words = [];

        splittedwords.forEach((word) => {
            //Das nächste Wort ist für die gesamte Zeilenlänge zu groß
            if (word.length > maxWordlength) {
                //Trennung nach /
                let arr = word.split("/")

                if (arr.length === 1) {
                    //Trennung unwirksam
                    //Wort am Ende abschneiden und mit - umbrechen
                    arr = [word.substr(0, maxWordlength - 1) + "-", word.substr(maxWordlength - 1)]
                } else {
                    for (let i = 1; i < arr.length; i++) {
                        arr[i] = "/".concat(arr[i]);
                    }
                }
                for (let element of arr) {
                    words = words.concat(this.fitTextToMaxWordlength(element, maxWordlength));
                }
            } else {
                words.push(word);
            }
        });

        return words;
    }

    /*
    Fügt dem ausdruck eine formatierte Zeile an
    key: linke Spalte (String)
    value: rechte Spalte (String)
    indentation: Einzug in dots der Value-Einträge von links gemessen (Integer)
    maxValueLength: Maximale Anzahl von Zeichen, die der Value annehmen darf, danach wird die Zeile umgebrochen
                    (Bei indentation=180 und Schriftgröße 1/1 entspricht diese maximal 27 Zeichen) (Integer)
                    (180 und 27 wird für Header verwendet)
    */
    addFormatedLine(key, value, indentation = 180, maxValueLength = 27, options = { reverse: false, underline: false, bold: false, linebreak: true }) {
        const reverse = options.reverse || false;
        const underline = options.reverse || false;
        const bold = options.bold || false;
        const linebreak = options.linebreak ? true : false;

        this.printer.addTextStyle(reverse, underline, bold, this.printer.COLOR_1);

        this.printer.addText(key);

        let words = this.fitTextToMaxWordlength(value, maxValueLength);

        let j = 0;

        do {
            //Neue Zeile
            let i = 0;
            this.printer.addTextPosition(indentation);

            while(j < words.length && (i + words[j].length) < maxValueLength) {
                //Innerhalb einer Zeile

                this.printer.addText(words[j]);
                i += words[j].length;

                if (i < maxValueLength) {
                    this.printer.addText(" ");
                    i++;
                }
                j++;
            }

            if (j < words.length)
                this.printer.addText("\n");

        } while (j < words.length);

        if (linebreak === true) {
            this.printer.addText("\n");
        }
    }

    //number: Die zu formatierende Zahl
    //integer: Anzahl der Vorkommastellen
    //deciamal: Anzahl der Nachkommastellen
    //filltext: Zeichenkette, welche pro führende Leerstelle eingefügt wird
    formatNumber(number, integer, decimals, filltext = " ") {
        let string = "";

        const numberintegers = (number | 0).toString().length

        while (integer-- > numberintegers) {
            string = string.concat(filltext);
        }

        //Vorkommastellen anhängen
        string = string.concat((number | 0));

        //Nachkommastellen
        if (decimals > 0) {
            string = string.concat(",");

            string = string.concat((number % 1).toFixed(decimals).substr(2));
        }
        return string;
    }

    printArticle(article, printArticlePrice) {
        this.addFormatedLine(this.formatNumber(article.quantity, 3, 0), article.name, this.articleIndentation, this.maxArticleValueLength, { bold: true, linebreak: false });

        if (printArticlePrice) {
            this.addFormatedLine("", this.formatNumber(article.price, 3, 2), 425, 7, { bold: true, linebreak: true });
        } else {
            this.printer.addText("\n");
        }

        if (article.featuresUnmapped) {
            article.featuresUnmapped.forEach(feature => {
                this.addFormatedLine('', feature.amount > 1 ? `${feature.amount}x ${feature.value}` : feature.value, this.articleIndentation, this.maxArticleValueLength, { bold: false, linebreak: true });
            });
        }
    }

    printOrderBodyLine(article, options) {
        this.printer.addTextStyle(false, false, true, this.printer.COLOR_1);

        this.printArticle(article, options.printArticlePrice);

        if (article.note) {
            this.addFormatedLine("", article.note, this.articleIndentation, this.maxArticleValueLength);
        }
    }

    printOrderFooter(articleList) {
        this.printer.addText("__________________________________________\n\n");

        this.printer.addTextSize(2, 2);

        this.addFormatedLine("", "Gesamt:", this.articleIndentation, this.maxArticleValueLength, { bold: true, linebreak: false });

        const totalPrice = articleList.reduce((sum, article) => sum + (article.price * (article.quantity || 1)), 0);

        this.addFormatedLine("", this.formatNumber(totalPrice, 3, 2), 350, 7, { bold: true, linebreak: true });
    }

    printOrder(head, articleList, options ) {

        if (!ePosDev.isConnected() || this.printer == null || !ePosDev.socket.socket.connected) {
            throw "EPosPrinter is currently disconnected";
        }

        //Head
        for (let entry of head) {
            this.addFormatedLine(entry[0], entry[1]);
        }

        this.printer.addText("__________________________________________\n\n");

        //Body
        for (let article of articleList) {
            this.printOrderBodyLine(article, options);
        }

        //Footer
        if (options.printTotalPrice) {
            this.printOrderFooter(articleList);
        }

        this.printer.addText("\n");

        this.printer.addCut();

        //Promise wird durch die onreceive Methode vom this.printer resolved
        return new Promise((resolveFunction) => {
            this.printqueue.push({ resolvefunc: resolveFunction, head: head, articleList: articleList, options: options });
            this.printer.send();
            window.setTimeout(() => {
                if (ePosDev.socket === null || !ePosDev.socket.socket.connected) {
                    console.log("Socket is not connected")
                    resolveFunction("Socket is currently closed");
                }
                this.printqueue.shift();
                //Timeout nach 10 Sekunden
            }, 10000);
        })
    }

    printArticleList(articleList) {
        if (!ePosDev.isConnected() || this.printer == null || !ePosDev.socket.socket.connected) {
            throw "EPosPrinter is currently disconnected";
        }

        this.printer.addTextSize(2, 2);
        this.printer.addText("Artikelliste\n");
        this.printer.addTextSize(1, 1);
        let aktDate = new Date();
        this.addFormatedLine("", moment().format('L') + " - " + moment().format('LT'), 0, 20, { bold: true, linebreak: true });

        this.printer.addText("__________________________________________\n\n");


        for (let article of articleList) {
            this.printArticle(article, false);
        }

        this.printer.addText("\n");
        this.printer.addText("\n");

        this.printer.addCut();

        //Promise wird durch die onreceive Methode vom this.printer resolved
        return new Promise((resolveFunction) => {
            this.printqueue.push({ resolvefunc: resolveFunction, articleList: articleList });
            this.printer.send();
            window.setTimeout(() => {
                if (ePosDev.socket === null || !ePosDev.socket.socket.connected) {
                    console.log("Socket is not connected")
                    resolveFunction("Socket is currently closed");
                }
                this.printqueue.shift();
                //Timeout nach 10 Sekunden
            }, 10000);
        })

    }

}

instance = new EPosPrinter();

export default instance;

